<template>
  <a-modal
    v-if="typeOfReview"
    v-model="showModal"
    header
    footer
    :width="windowWidth"
    class="custom-recommend-modal"
    :centered="true"
    :dialog-style="{ margin: '0px' }"
    @cancel="hide"
  >
    <div
      v-if="!reviewComplete"
      class="recommend-container"
      :style="{ background: getPrimaryColor() }"
    >
      <div class="blue-part" :style="{ background: getPrimaryColor() }">
        <div class="blue-content" :style="{ width: '500px' }">
          <img
            v-if="getImage()"
            :src="getImage()"
            alt="medication"
            class="round"
          />
          <img
            v-else
            src="../../assets/icons/medication-default.png"
            alt="medication"
            class="round"
          />
          <h4 class="white fw700">You are Reviewing</h4>
          <h1 class="white selected-profile-name fw700">
            {{ getMedicineName() }}
          </h1>
          <a
            :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
            class="white guidelines hide-in-mobile"
            target="_blank"
            >Guidelines for Reviewing</a
          >
        </div>
      </div>
      <div class="white-container">
        <div class="white-part h-100">
          <div v-if="typeOfReview === 'patient'">
            <div v-for="(review, ind) in patientReviews" :key="ind">
              <div v-if="currentPage === ind">
                <p class="count">
                  {{ ind + 1 }} of {{ patientReviews.length }}
                </p>
                <h1 class="review-title">{{ review.heading }}</h1>
                <p class="rev-desc" v-if="ind < patientReviews.length - 1">
                  {{ review.description }}
                </p>
                <div v-if="ind < patientReviews.length - 1" class="star-box">
                  <a-icon
                    v-for="i in [1, 2, 3, 4, 5]"
                    :key="i"
                    class="star-rating-recommend"
                    :class="
                      i > patientReviews[ind].rating ? 'silver' : 'golden'
                    "
                    type="star"
                    @mouseover="getHover(i, ind)"
                    @mouseleave="removeHover(ind)"
                    @click="putRating(i)"
                    theme="filled"
                  />
                </div>
                <h3 v-if="ind < patientReviews.length - 1" class="rating">
                  {{ ratingConverter(patientReviews[ind].rating) }}
                </h3>
                <h3
                  v-if="geth && !ind < patientReviews.length - 1"
                  class="rating"
                >
                  {{ geth }}
                </h3>
                <div v-if="ind === patientReviews.length - 1" class="text-box">
                  <a-textarea
                    :placeholder="getReviewInputPlaceholder('medication')"
                    v-model="patientReviews[ind].rating"
                    :rows="6"
                    :maxlength="2500"
                  />
                  <p class="text-right small-text">
                    {{
                      patientReviews[ind].rating
                        ? patientReviews[ind].rating.length
                        : 0
                    }}/2500
                  </p>
                </div>
                <div class="arrows">
                  <font-awesome-icon
                    v-if="currentPage > 0"
                    :icon="['fas', 'chevron-left']"
                    class="font24 gray400 cp"
                    @click="currentPage = currentPage - 1"
                  />
                </div>
                <p
                  v-if="ind === patientReviews.length - 1"
                  class="small-text text-center gray900 font12 mb-3"
                >
                  By clicking “Submit” you agree to be at least 18 years old.
                </p>
                <button
                  @click="submitReview"
                  v-if="ind === patientReviews.length - 1"
                  class="dovemed-button font-white mb-2 w-100"
                  :style="{ background: getPrimaryColor() }"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <div v-if="typeOfReview === 'provider'">
            <div v-for="(review, ind) in providerReviews" :key="ind">
              <div v-if="currentPage === ind">
                <p class="count">
                  {{ ind + 1 }} of {{ providerReviews.length }}
                </p>
                <h1 class="review-title">{{ review.heading }}</h1>
                <p class="rev-desc" v-if="ind < providerReviews.length - 1">
                  {{ review.description }}
                </p>
                <div v-if="ind < providerReviews.length - 1" class="star-box">
                  <a-icon
                    v-for="i in [1, 2, 3, 4, 5]"
                    :key="i"
                    class="star-rating-recommend"
                    :class="
                      i > providerReviews[ind].rating ? 'silver' : 'golden'
                    "
                    type="star"
                    @mouseover="getHover(i, ind)"
                    @mouseleave="removeHover(ind)"
                    @click="putRating(i)"
                    theme="filled"
                  />
                </div>
                <h3 v-if="ind < providerReviews.length - 1" class="rating">
                  {{ ratingConverter(providerReviews[ind].rating) }}
                </h3>
                <h3
                  v-if="geth && !ind < providerReviews.length - 1"
                  class="rating"
                >
                  {{ geth }}
                </h3>
                <div v-if="ind === providerReviews.length - 1" class="text-box">
                  <a-textarea
                    :placeholder="getReviewInputPlaceholder('medication')"
                    v-model="providerReviews[ind].rating"
                    :rows="6"
                    :maxlength="2500"
                  />
                  <p class="text-right small-text">
                    {{
                      providerReviews[ind].rating
                        ? providerReviews[ind].rating.length
                        : 0
                    }}/2500
                  </p>
                </div>
                <div class="arrows">
                  <font-awesome-icon
                    v-if="currentPage > 0"
                    :icon="['fas', 'chevron-left']"
                    class="font24 gray400 cp"
                    @click="currentPage = currentPage - 1"
                  />
                </div>
                <button
                  @click="submitReview"
                  v-if="ind === providerReviews.length - 1"
                  class="dovemed-button font-white mb-2"
                  :style="{ background: getPrimaryColor() }"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="typeOfReview === 'advocate'"
            class="flex-center-center flex-column h-100"
          >
            <h3 class="gray900 fw700 font32 mb-4">
              Have you taken this medication in the past?
            </h3>
            <div class="d-flex justify-content-center gap10 yesNoContainer">
              <div
                class="p1224 bg-gray200 br6 font14 fw700 gray600 cp"
                @click="() => (typeOfReview = 'patient')"
              >
                Yes
              </div>
              <div
                class="p1224 bg-gray200 br6 font14 fw700 gray600 cp"
                @click="() => (typeOfReview = 'not taken')"
              >
                No
              </div>
            </div>
          </div>
          <div
            v-if="typeOfReview === 'not taken'"
            class="flex-center-center flex-column h-100"
          >
            <font-awesome-icon
              :icon="['fas', 'times-circle']"
              class="error300 mb-4"
              :style="{ height: 'calc(2*100px/3)' }"
            />
            <h6 class="font18 fw700 gray500 mb-4">
              You can only review a medication if you had taken it in the past.
            </h6>
            <font-awesome-icon
              :icon="['fas', 'chevron-left']"
              class="font24 gray400 cp"
              @click="() => (typeOfReview = 'advocate')"
            />
          </div>
        </div>
      </div>
      <a
        :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
        class="white guidelines show-in-mobile"
        target="_blank"
        >Guidelines for Reviewing</a
      >
    </div>
    <div
      v-if="reviewComplete"
      class="recommend-container"
      :style="{ background: getPrimaryColor() }"
    >
      <div
        class="blue-part w-100 end-height p-5"
        :style="{ background: getPrimaryColor() }"
      >
        <div v-if="treatment" class="blue-content reviewDone">
          <img
            v-if="getImage()"
            :src="getImage()"
            alt="medication"
            class="round"
          />
          <img
            v-else
            src="../../assets/icons/medication-default.png"
            alt="medication"
            class="round"
          />
          <h1 class="white font24">Thanks for Reviewing</h1>
          <h1 class="white fw700">{{ getMedicineName() }}</h1>
          <div
            class="d-flex flex-column bg-white br100 align-items-center m-auto"
            :style="{ padding: '24px 120px', width: 'fit-content' }"
          >
            <h4 class="gray900 fw700 font24 mb-3">Your Rating</h4>
            <ReviewStar :rating="avgRating" :height="30" :width="30" />
            <p class="mb-0 mt-2 gray900 fw700 font20">
              {{ avgRating + " stars" }}
            </p>
          </div>
          <button
            @click="handleRevCompleteClose"
            class="close dovemed-button font-white mt-3"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import ReviewStar from "../commons/ReviewStar.vue";

const UserRepository = RepositoryFactory.get("user");

export default {
  components: { ReviewStar },
  name: "MedicationReview",
  props: {
    treatment: Object,
    getMedReviews: Function,
    getTreatmentDetails: Function,
  },
  data() {
    return {
      reviewStarClicked: false,
      patientReviews: [
        {
          key: "accessibility",
          heading: "Accessibility",
          description:
            "How difficult is it to get the medication in your area?",
          rating: 0,
        },
        {
          key: "affordability",
          heading: "Affordability",
          description: "How affordable is this medication in your area?",
          rating: 0,
        },
        {
          key: "ease_of_use",
          heading: "Ease of use",
          description: "Is the medication simple and easy to use?",
          rating: 0,
        },
        {
          key: "effectiveness",
          heading: "Effectiveness",
          description: "Has the medication been effective for your condition?",
          rating: 0,
        },
        {
          key: "side_effects",
          heading: "Side effects",
          description: "Are the side effects of the medication very severe?",
          rating: 0,
        },
        {
          key: "description",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          rating: null,
        },
      ],
      providerReviews: [
        {
          key: "accessibility",
          heading: "Accessibility",
          description:
            "How difficult is it to get the medication in your area?",
          rating: 0,
        },
        {
          key: "adherence_by_patients",
          heading: "Adherence by patients",
          description: "How affordable is this medication in your area?",
          rating: 0,
        },
        {
          key: "affordability",
          heading: "Affordability",
          description: "How affordable is this medication for your patients?",
          rating: 0,
        },
        {
          key: "availability_of_alternatives",
          heading: "Availability of alternatives",
          description:
            "Are there suitable alternatives available for the medication?",
          rating: 0,
        },
        {
          key: "drug_interactions",
          heading: "Drug interactions",
          description: "Does the medication lead to severe drug interactions?",
          rating: 0,
        },
        {
          key: "effectiveness",
          heading: "Effectiveness",
          description: "Has the medication been effective for your patients?",
          rating: 0,
        },
        {
          key: "safety",
          heading: "Safety",
          description: "How safe is the medication in terms of drug dosage?",
          rating: 0,
        },
        {
          key: "tolerability",
          heading: "Tolerability",
          description: "Do your patients tolerate the medication well?",
          rating: 0,
        },
        {
          key: "description",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          rating: null,
        },
      ],
      currentPage: 0,
      typeOfReview: null,
      reviewComplete: false,
      showModal: false,
      geth: null,
      hm: 0,
      avgRating: 0,
      windowWidth: 1000,
    };
  },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
  methods: {
    show() {
      switch (this.authUser.user.role) {
        case "patient":
        case "caregiver":
          this.typeOfReview = "patient";
          break;
        case "advocate":
          this.typeOfReview = "advocate";
          break;
        case "doctor":
        case "physician":
        case "ahp":
        case "ahcp":
        case "hcp":
        case "ohcp":
        case "amp":
        case "app":
        case "other":
        case "nfp":
        case "nfp_administrator":
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
        case "business":
        case "business_administrator":
          this.typeOfReview = "provider";
          break;
        default:
          this.typeOfReview = null;
      }
      this.showModal = true;
      if (!this.typeOfReview) {
        this.$notification.error({
          message: "Denied",
          description: `${this.authUser.user.role} cannot review`,
        });
      }
    },
    getImage() {
      return this.treatment.url || null;
    },
    getMedicineName() {
      return this.treatment.display_name;
    },
    getHoverType(i, index, reviewType) {
      if (!reviewType[index].rating) {
        this.geth = this.ratingConverter(i);
        this.hm = document.getElementsByClassName("star-rating-recommend");
        for (let j = 0; j < 5; j++) {
          if (j < i) {
            this.hm[j].classList.remove("silver");
            this.hm[j].classList.add("golden");
          } else {
            this.hm[j].classList.add("silver");
            this.hm[j].classList.remove("golden");
          }
        }
      }
    },
    getHover(i, index) {
      switch (this.typeOfReview) {
        case "patient":
          this.getHoverType(i, index, this.patientReviews);
          break;
        case "provider":
          this.getHoverType(i, index, this.providerReviews);
          break;
      }
    },
    removeHoverType(index, reviewType) {
      this.geth = null;
      this.hm = document.getElementsByClassName("star-rating-recommend");
      if (!reviewType[index].rating) {
        for (let j = 0; j < 5; j++) {
          this.hm[j].classList.add("silver");
          this.hm[j].classList.remove("golden");
        }
      }
      this.hm = 0;
    },
    removeHover(index) {
      switch (this.typeOfReview) {
        case "patient":
          this.removeHoverType(index, this.patientReviews);
          break;
        case "provider":
          this.removeHoverType(index, this.providerReviews);
          break;
      }
    },
    ratingConverter(num) {
      const array = [" ", "WORST", "POOR", "AVERAGE", "GOOD", "EXCELLENT"];
      return array[num];
    },
    putRating(i) {
      this.geth = null;
      switch (this.typeOfReview) {
        case "patient":
          this.patientReviews[this.currentPage].rating = i;
          // this.currentPage + 1 < this.patientReviews.length && (this.currentPage = this.currentPage + 1)
          if (!this.reviewStarClicked) {
            this.reviewStarClicked = true;
            setTimeout(() => {
              this.currentPage + 1 < this.patientReviews.length &&
                (this.currentPage = this.currentPage + 1);
              this.reviewStarClicked = false;
            }, 500);
          }
          break;
        case "provider":
          this.providerReviews[this.currentPage].rating = i;
          // this.currentPage + 1 < this.providerReviews.length &&
          //   (this.currentPage = this.currentPage + 1);
          if (!this.reviewStarClicked) {
            this.reviewStarClicked = true;
            setTimeout(() => {
              this.currentPage + 1 < this.providerReviews.length &&
                (this.currentPage = this.currentPage + 1);
              this.reviewStarClicked = false;
            }, 500);
          }
          break;
      }
    },
    submitReview() {
      let currentReviewType = "";
      let currentReviewArray = [];

      switch (this.typeOfReview) {
        case "patient":
          currentReviewType = "patient";
          currentReviewArray = this.patientReviews;
          break;
        case "provider":
          currentReviewType = "provider";
          currentReviewArray = this.providerReviews;
          break;
      }

      const payload = {};
      let rate = 0;
      currentReviewArray.forEach((rev, i) => {
        payload[rev.key] = rev.rating;
        if (i < currentReviewArray.length - 1) {
          rate = rate + rev.rating;
        }
      });
      this.avgRating = Number(
        (rate / (currentReviewArray.length - 1)).toFixed(1)
      );

      payload["rating"] = this.avgRating;
      payload["type"] = currentReviewType;
      payload["medication_type"] = this.treatment.treatment_type;
      payload["medication_id"] = this.treatment.id;
      payload["medication_name"] = this.treatment.display_name;
      payload["reviewer_role"] = this.authUser.user.role;
      payload["circle_id"] = this.currentCircle.id;
      payload["reviewer_id"] =
        this.authUser.user.role === "patient" ||
        this.authUser.user.role === "advocate" ||
        this.authUser.user.role === "caregiver"
          ? this.authUser.user.id
          : this.authUser.user.ext_ref_id;
      // payload["reviewer_id"] = this.authUser.user.id

      UserRepository.reviewMedication(payload)
        .then((res) => {
          this.reviewComplete = true;
        })
        .catch((err) => {
          this.$notification.error({
            message: "Failed",
            description: "Already Reviewed",
          });
        });
    },
    handleRevCompleteClose() {
      this.showModal = false;
      this.getMedReviews();
      this.getTreatmentDetails();
    },
    hide() {
      this.showModal = false;
      this.typeOfReview = null;
      if (this.reviewComplete) {
        this.getMedReviews();
        this.getTreatmentDetails();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .yesNoContainer {
    flex-direction: column;
    div {
      width: 100%;
    }
  }
}
.ant-modal-centered .ant-modal {
  height: 100vh !important ;
  width: auto !important;
}
.ant-modal {
  width: auto !important;
  margin: 0px !important;
  padding: 0 !important;
}
.ant-modal-wrap {
  overflow: hidden !important;
}
.white-container {
  width: 100%;
  min-height: 550px;
}
.guidelines {
  margin-top: 100px;
  line-height: 24px;
  text-align: center;
  text-decoration-line: underline;
  color: #ffffff !important;
}
.custom-recommend-modal {
  .ant-modal-body {
    .recommend-container {
      .blue-part {
        padding: 70px 0 !important;
        @media screen and (max-width: 600px) {
          padding: 24px !important;
        }
        .font24 {
          font-size: 24px !important;
        }
        .white-rate-container {
          width: 200px !important;
          border-radius: 8px !important;
        }
      }
      .white-part {
        h1.review-title {
          width: auto !important;
        }
      }
    }
  }
}
.dovemed-button {
  border-radius: 8px !important;
}
.ant-modal-content {
  border-radius: 8px !important;
  overflow: hidden !important;
}
.bg-gray200:hover {
  background: #cbd5e1 !important;
}
img {
  border: 1px solid #f8fafd;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/MedicationReview.vue